/**
 * Convert Date object into formatted date and time string
 * @param {Date} date Input date object
 * @return {string} Formatted date and time (13. Juli 2018, 12:30)
 */
export default function (date) {
  if (typeof date.getMonth !== 'function') {
    return 'Invalid Date'
  }

  return date.toLocaleString('de-DE', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}
